import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-imprimatur',
  templateUrl: './imprimatur.component.html',
  styleUrls: ['./imprimatur.component.scss']
})
export class ImprimaturComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
